import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../App';
import dao from '../../../assets/img/dao.png'
import postnord from '../../../assets/img/postnord.png'
import gls from '../../../assets/img/gls.png'
import bring from '../../../assets/img/bring.png'
import { LoadingOverlay } from '../../loading';

export const BookDetails = ({book, loadingBook}) => {
  return (
    <div className="flex flex-col gap-2" id="bookDetails">
      <div className="text-sm font-medium text-gray-900">
        <h2>Bogoplysninger</h2>
      </div>
      <div className="bookInfo relative flex items-center gap-10 border border-neutral-300 w-full">
        {loadingBook &&
          <LoadingOverlay />}
        <div className="bookDetails w-full flex-wrap md:px-5">
          <div className="title w-full flex flex-col md:flex-row justify-between items-center p-5 gap-y-2">
            <p className="font-medium flex-[1] mr-auto">ISBN</p>
            <div className="flex-[1] w-full">
              <input type="text" disabled value={(Object.keys(book).length !== 0) ? book['isbn'] : ""} className="block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200 w-full" required />
            </div>
          </div>
          <div className="title w-full flex flex-col md:flex-row justify-between items-center p-5 border-t border-neutral-100 gap-y-2">
            <p className="font-medium flex-[1] mr-auto">Titel</p>
            <div className="flex-[1] w-full">
              <input type="text" disabled value={(Object.keys(book).length !== 0) ? book['title'] : ""} className="block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200 w-full" required />
            </div>
          </div>
          <div className={"title w-full flex flex-col md:flex-row justify-between p-5 gap-y-2" + (Object.keys(book).length !== 0 ? "" : " items-center")}>
            <p className="font-medium flex-[1] mr-auto">Forfatter</p>
            <div className="flex-[1] w-full">
              {
                (Object.keys(book).length !== 0) ? (
                  <div className="flex flex-col gap-2 w-full">
                    {book['director'].length > 0 ?
                      book['director'].map((data) => {  
                        return (
                          <input type="text" disabled value={data['$']} className="block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200" required />
                        )
                      })
                    :
                      <input type="text" disabled value="Ukendt forfatter" className="block focus:outline-none p-4 text-sm text-gray-500 border-b border-neutral-200" required />
                    }
                  </div>
                ) :
                  <input type="text" disabled value="" className="block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200 w-full" required />
              } 
            </div>
          </div>
          {(Object.keys(book).length !== 0) ?
            (book['version'] !== '') ? 
              <div className="title w-full flex flex-col md:flex-row justify-between items-center p-5 gap-y-2">
                <p className="font-medium flex-[1] mr-auto">Udgave</p>
                <div className="flex-[1] w-full">
                  <input type="text" disabled value={(Object.keys(book).length !== 0) ? book['version'] : ""} className="flex-[1] block focus:outline-none p-4 text-sm text-gray-900 border-b border-neutral-200 w-full" required />
                </div>
              </div>
            :
              ""
          :
            ""}
        </div>
      </div>
    </div>
  )
}